export async function fetchSFUCourseDetails(year, term, department, courseNumber, section) {
  const baseURL = 'https://www.sfu.ca/bin/wcm/course-outlines';
  const url = `${baseURL}?${year}/${term}/${department}/${courseNumber}/${section}`;

  try {
    const response = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!response.ok) {
      throw new Error(`SFU API error: status ${response.status}`);
    }
    const data = await response.json();
    return data; // expected to include courseSchedule, title, deliveryMethod, units, etc.
  } catch (err) {
    console.error('Error fetching SFU course details:', err);
    return null;
  }
}

/**
 * Fetches all section data for a given course (dept/number) from SFU's Course Outlines API.
 */
export async function fetchSFUSections(year, term, dept, courseNumber) {
  const baseUrl = "https://www.sfu.ca/bin/wcm/course-outlines";
  const queryString = `?${year}/${term}/${dept}/${courseNumber}`;
  const url = baseUrl + queryString;
  console.log("Fetching sections URL:", url);
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`SFU API error for sections: status ${response.status}`);
  }
  return await response.json();
}